import { User } from "../../../types";
import { styled } from "@mui/material";
import ContentUpload from "../../Scan/components/ContentUpload";
import { useState } from "react";
import { ActionBtn } from "../../../components/Typography";

type ProfilePictureProps = {
  user: User;
};

const ProfilePicture = ({ user }: ProfilePictureProps) => {
  const [file, setFile] = useState<File | undefined>(undefined);

  const handleUpload = () => {
    try {
      console.log(file);
    } catch (error: any) {
      console.log({ error });
    }
  };

  if (user.profilePicture) {
    return <Picture src={user.profilePicture} />;
  } else {
    return (
      <Wrap sx={{ display: "none" }}>
        <ContentUpload
          sx={{ backgroundColor: "transparent" }}
          additionalSx={{ flexDirection: "column" }}
          cropperStyle={{ height: "200px" }}
          setFile={setFile}
        />
        {file && <ActionBtn onClick={handleUpload}>Upload</ActionBtn>}
      </Wrap>
    );
  }
};

const Wrap = styled("div")`
  display: flex;
  width: 100%;
  max-width: 50%;
  margin-left: auto;
`;

const Picture = styled("img")`
  font-size: 170px;
  border-radius: 50%;
  height: 125px;
  width: 125px;
  border: none;
  @media (max-width: 560px) {
    width: 75px;
    height: 75px;
  }
`;

export default ProfilePicture;
